import { Stack, Typography } from '@mui/material';
import React from 'react';

const ProfileLoader = () => (
  <Stack justifyContent="center" alignItems="center" height="100%" width="100%">
    <Typography variant="h6">Loading...</Typography>
  </Stack>
);

export default ProfileLoader;
